/*
 * @Author: Yu JiaZe
 * @Description:
 * @Date: 2020-01-03 15:31:33
 * @LastEditTime : 2020-01-07 18:34:49
 */

export function sleep(time: number) {
    return new Promise((resolve) => {
        setTimeout(resolve, time);
    });
}
